import { DEFAULT_LANGUAGE, answersOfLength, type Language } from '@lexicon/core';

/**
 * A word for this rung, uniformly at random, never today's daily answer
 * (spec §10.3 — playing the same word twice in one day would spoil the
 * daily). Core stays pure: the randomness is injected here, at the edge,
 * and `random` is injectable so tests are deterministic.
 */
export function pickJourneyWord(
  rung: number,
  excludeWord: string,
  random: () => number = Math.random,
  language: Language = DEFAULT_LANGUAGE,
): string {
  const pool = answersOfLength(rung, language);
  if (pool.length === 0) throw new Error(`no answers for journey rung ${rung}`);
  // Filtering (rather than re-rolling or nudging the index) keeps the
  // distribution exactly uniform over the words that are actually allowed.
  const choices = pool.filter((word) => word !== excludeWord);
  const from = choices.length > 0 ? choices : pool;
  // random() is documented as [0, 1), but clamping costs nothing and an
  // out-of-range index here would hand `createGame` an undefined answer.
  const index = Math.min(from.length - 1, Math.max(0, Math.floor(random() * from.length)));
  return from[index]!;
}
